<template>
  <b-modal
    v-model="showModal"
    :title="`Detalles del flujo para el Expediente ${file.numero}`"
    ok-title="Vale"
    size="lg"
    ok-only
  >
    <div class="row">
      <div class="col-12">
        <h4
          v-if="fileOnFlow.detalle && fileOnFlow.detalle.documentosBase
           && fileOnFlow.detalle.documentosBase.length"
        >
          Detalles del Flujo para el
          documento {{fileOnFlow.detalle.documentosBase[0].objetoNombre}}
        </h4>
      </div>
      <div class="col-12">
        <div class="row mb-3">
          <h5 class="col-12 mt-4">
            Archivos adjuntos
          </h5>
          <vs-table
            class="col-12 box-attachments"
            stripe
            :data="(fileOnFlowAttachments || [])"
            noDataText="No hay documentos"
          >
            <template slot="header">
            </template>
            <template slot="thead">
              <vs-th>
                Nombre Adjunto
              </vs-th>
              <vs-th>
                Tipo
              </vs-th>
              <vs-th>
                Ver
              </vs-th>
            </template>
            <template>
              <tbody>
              <vs-tr
                v-for="attachment in fileOnFlowAttachments"
                :key="attachment.url"
              >
                <vs-td>
                  {{ attachment.nombreCompleto }}
                </vs-td>
                <vs-td>
                  <span v-if="attachment.esInicial">
                    principal
                  </span>
                  <span v-if="!attachment.esInicial">
                    adjunto
                  </span>
                </vs-td>
                <vs-td>
                  <span
                    v-on:click="selectFile(attachment)"
                    style="cursor:pointer;width: fit-content;"
                  >
                     <feather-icon icon="FileTextIcon" size="14" />
                  </span>
                </vs-td>
              </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
        <div class="">
          <div class="col-6">
            <pdf
              class="mt-2"
              v-for="i in numPages"
              :key="i"
              :page="i"
              :src="selectedFile"
            />
          </div>
        </div>
      </div>
      <div class="col-6">
        <h5 class="my-3">
          Pasos
        </h5>
        <Steps
          v-if="fileOnFlow.detalle && fileOnFlow.detalle.pasos"
          :steps="fileOnFlow.detalle.pasos"
          :ejecucion="fileOnFlow.detalle.ejecucion"
        />
      </div>
      <div class="col-6">
        <h5 class="my-3">
          Bitácora
        </h5>
        <binnacle v-if="binnacleFile.length" />
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import { rolTypesCode } from '@/febos/chile/approvals/components/trays/managementTray/constants';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import Steps from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Steps';
import Binnacle from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Binnacle';

export default {
  name: 'PopUpDetailFile',
  props: {
    file: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  components: {
    Steps,
    Binnacle
  },
  data() {
    return {
      stepTypes: StepTypes,
      selectedFile: '',
      numPages: undefined
    };
  },
  computed: {
    ...mapGetters('Approvals', [
      'binnacleFile',
      'fileOnFlow',
      'fileOnFlowAttachments'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    showModal: {
      get() {
        return this.modalName === 'flowFile';
      },
      set() {
        this.closeModal();
      }
    },
    isOffice() {
      const { pasos } = this.fileOnFlow.detalle;
      const { ejecucion } = this.fileOnFlow.detalle;
      return (pasos || [])
        .some((step) => (
          step.id === ejecucion.pasoActualId
          && step.paso.aprobacionesTipoPasoId === this.stepTypes.OFFICE.toString()
        ));
    },
    isSigner() {
      const { pasos } = this.fileOnFlow.detalle;
      const { ejecucion } = this.fileOnFlow.detalle;
      return (pasos || [])
        .some((step) => (
          step.id === ejecucion.pasoActualId
          && step.paso.aprobacionesTipoRolId === rolTypesCode.firmante
        ));
    },
    stepId() {
      const { pasos } = this.fileOnFlow.detalle;
      const { ejecucion } = this.fileOnFlow.detalle;
      return this.fileOnFlow.detalle && (pasos || [])
        .find((step) => step.id === ejecucion.pasoActualId);
    },
    canReturn() {
      const { ejecucion } = this.fileOnFlow.detalle;
      const { pasos } = this.fileOnFlow.detalle;
      const actualStep = (pasos || [])
        .find((step) => step.id === ejecucion.pasoActualId);
      const { reversible } = ejecucion;
      const isTemporal = actualStep.esTemporal;
      const returnStep = actualStep.numeroPaso.toString() !== '1' && reversible && !isTemporal;
      return returnStep;
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    selectFile(file) {
      window.open(file.url, '_blank');
    }
  }
};
</script>
<style scoped>

.pill-info-attach {
  border: 1px solid #3ca2d6;
  padding: 1px 5px;
  border-radius: 10px;
  font-size: 12px;
  margin-right: 5px;
  cursor:pointer;
}

.box-participants {
  max-height: 300px;
  overflow-y: scroll;
}
.vs-popup--content {
  overflow-x: hidden !important;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 10px 15px;
  background: #6f1788 !important;
  color: white !important;
}

.vs-list--item {
  border: none !important;
}
.vs-list--item:last-child {
  border: none !important;
}

.wrap-table {
  max-height: 200px;
  overflow-y: scroll;
}

.wrap-table-large {
  max-height: 300px;
  overflow-y: scroll;
}
</style>
